import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { environment } from '../../../../../environments/environment';

const env = environment;

@Component({
  selector: 'app-paso-uno',
  templateUrl: './paso-uno.component.html',
  styleUrls: ['./paso-uno.component.scss']
})
export class PasoUnoComponent implements OnInit {
  validacionCheck = false;
  validacion: any;
  rutEmpresaValido = false;
  irPaso2 = false;
  get created() {return this.flujos.paso1Created; }

  /* Validacion de inputs */
  public dataPasoUno: FormGroup = new FormGroup({
    seleccionFlujo: new FormControl('personaNatural', [Validators.required]),
    autorizacion: new FormControl('', [Validators.requiredTrue])
  });

  @Output() nextStep: EventEmitter<any> = new EventEmitter();
  seleccionFlujo: any;

  constructor(
    private flujos: FlujosPaso2Service,
    private stepperService: StepperServiceVM,
    private carroService: CarroComprasService) {
  }

  ngOnInit() {
    if (window.innerWidth < 1200) {
      this.carroService.hide();
    }
  }

  onNextStep(): void {
    this.nextStep.emit();

  }

  fixForm() {
    this.dataPasoUno.get('seleccionFlujo').setValue('personaJuridica');
  }

  public getRetomar() {
    return this.carroService.getRetoma();
  }

}
